var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _path14, _g, _ellipse2, _ellipse3, _path15, _ellipse4, _path16, _g2, _ellipse5, _ellipse6, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse7, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 440.64 753.62",
    className: "image image-responsive",
    "data-v-03e48ff6": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20",
    x1: -5347.36,
    y1: 216.87,
    x2: -5347.21,
    y2: 216.87,
    gradientTransform: "translate(5728.29)",
    gradientUnits: "userSpaceOnUse",
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deac00",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deac00",
    stopOpacity: 0,
    "data-v-03e48ff6": ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 308.52,
    y1: 394.57,
    x2: 308.52,
    y2: 235.51,
    gradientUnits: "userSpaceOnUse",
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0,
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    "data-v-03e48ff6": ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 287.49,
    y1: 97.87,
    x2: 365.42,
    y2: 97.87,
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-2",
    x1: 291.99,
    y1: 195.76,
    x2: 360.85,
    y2: 195.76,
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-2",
    x1: 326.05,
    y1: 645.83,
    x2: 326.05,
    y2: 412.58,
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-3",
    x1: 291.99,
    y1: 718.02,
    x2: 311.98,
    y2: 718.02,
    gradientTransform: "rotate(.81 3407.82 1954.45)",
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-4",
    x1: 250.81,
    y1: 762.21,
    x2: 296.02,
    y2: 762.21,
    gradientTransform: "rotate(.81 3407.82 1954.45)",
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-5",
    x1: 327.12,
    y1: 776.2,
    x2: 347.2,
    y2: 776.2,
    gradientTransform: "rotate(1.82 3514.742 1956.474)",
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-6",
    x1: 286.02,
    y1: 820.36,
    x2: 331.22,
    y2: 820.36,
    gradientTransform: "rotate(1.82 3514.742 1956.474)",
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-3",
    x1: 365.18,
    y1: 399.86,
    x2: 365.18,
    y2: 215.11,
    xlinkHref: "#Degradado_sin_nombre_3",
    "data-v-03e48ff6": ""
  }), /*#__PURE__*/React.createElement("style", {
    "data-v-03e48ff6": ""
  }, ".cls-2{fill:#ffd0a2}.cls-3{fill:#6d990d}.cls-4{fill:#3f2f1e}.cls-9{fill:#403f3d}.cls-10{fill:#393937}.cls-11{fill:#fff}.cls-12{opacity:.05}.cls-13{fill:#161614}.cls-14{fill:#914a0e}.cls-15{mix-blend-mode:overlay;opacity:.4}.cls-18,.cls-33{opacity:.2}.cls-24{fill:#333}.cls-26{fill:#ffcd26}.cls-31{fill:#57453f}.cls-39{fill:#b3b3b3}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    "data-v-03e48ff6": ""
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.32 215c-14.32-4.5-4 27.13-11.62 80.44-1.51 10.56-2.9 34.76-6.23 45.66-.63 14.53 12.43 11.21 13.66 7 5.87-20.27 24.76-126.62 4.19-133.1z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.47 341.11c-12 24.05-35.6 79.12-35.6 79.12l5.3 9.67s38.56-70.3 44-81.8c3.99-11.79-8.28-17.81-13.7-6.99z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.21 427a29.51 29.51 0 003.12-9.7c2.31-15.28-15-20.53-23.23 7.5l-.18.06c-1.89 5.29-4.11 27-2.4 27.55 1.27.42 2.51-.12 3.07-1.84-.44 5.42-.47 10 .3 10.27 1.71.58 3.4-.6 3.37-4.13 0-1.73 1.28-7.56 2.68-13.28-.51 8-.5 17.34.55 17.58 1.61.36 3.1-1 2.86-4.49-.12-1.9 1-9.05 2.06-15.44-.47 7.65-.48 15.59.55 15.83 1.75.41 3.33-.94 3-4.45-.31-3.03 2.93-19.46 4.25-25.46z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.55 227s-.8 91.29-5.59 108.11l-27.69 61.42 14.37 6.71 29.75-51.8s25.72-144 3.88-150.87C279.9 203.86 279.55 227 279.55 227z",
    className: "cls-3",
    "data-v-03e48ff6": ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.5 194.13c-2.18-7.3-3.28-5.78-11.81-45.87s8.37-77.49 38.77-82.4c23.54-3.8 49.54-4.11 60.29 29.86 3.12 9.86 11.2 21.69 9.84 38.29-.78 9.49-7.58 27.89-7.17 35 2.74 47.2-80.81 55.7-89.92 25.12z",
    className: "cls-4",
    "data-v-03e48ff6": ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.27 84.09c10.28-5.5 48.86 12.82 52.35 26.87s18.28 45.13-2.1 81c-15.93 28-69.73 27.8-69.73 11.59s-4.46-106.67 19.48-119.46z",
    className: "cls-4",
    "data-v-03e48ff6": ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376 387.15c-20.11-21.91-90.68-66.18-105.59-1.21-1.76 37.19 2 131.82 2 131.82l22.47 137.83c8.17 4.82 9.23-1.13 19.82 1.53L298.66 528s8.09-64.38 8.48-102.62c1.79.14 13.7 1.86 20.65 1.7 2.9 26.57 3.11 49.11 10 98.84L352.39 667c3.77-4.61 15.3-3.88 20.58.11l-11-142.69S376 428.43 376 387.15z",
    fill: "#294950",
    "data-v-03e48ff6": ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.93 216.89h.15-.15z",
    fill: "url(#Degradado_sin_nombre_20)",
    opacity: 0.29,
    "data-v-03e48ff6": ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.4 385.94s14 11.42 57.05 11.42S376 387.15 376 387.15s-15.53-30.28-19.89-61.94c-2.81-20.35 28.74-111.39 4.71-126.62 0 0-10.24-6.69-40-6.69s-32.14 12.7-32.14 12.7c-.6 12.76-19.38 58.44-14.54 78.06a128.82 128.82 0 014 30.59c-.03 36.45-7.74 72.69-7.74 72.69z",
    className: "cls-3",
    "data-v-03e48ff6": ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.19 235.51S317.57 264 318.1 278s.53 67.1 2.66 76.05 12.24 14.54 0 19-34.05 2.8-34.05 2.8-5.32-2.24-5.32-10.63 6.92-87.79 5.85-86.11-16 103.45-16 103.45 22.88 14 43.1 11.74 31.39-6.71 31.39-6.71-4.26-31.31-4.79-50.33-4.75-101.75-4.75-101.75z",
    fill: "url(#Degradado_sin_nombre_3)",
    "data-v-03e48ff6": ""
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292 206.6c5.83 8.35 17.73 24.48 17.73 24.48s50.19-20.57 49-30c0 0 2.12-32.54 3.18-67 .78-25.51-4.5-58.13-31.76-58.13S287 82 287.49 109.25c.31 17.91 4.51 97.35 4.51 97.35z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.62 121.35a1.58 1.58 0 011.12-2.36A42.27 42.27 0 01343 120a29.42 29.42 0 0110.55 5.39 28.17 28.17 0 012.66 2.83s-7.71-4.13-13.34-4.86c-7.12-.93-9.27-1-12.49-.62A1.48 1.48 0 01329 122zM307.84 120.47a2 2 0 00-.43-2.82 21.29 21.29 0 00-8.52-2.66 15.81 15.81 0 00-8.19 2.11 22.67 22.67 0 00-2.44 1.94s6-1.72 9.86-.8c4.39 1.06 5.95 1.62 7.69 2.66a1.53 1.53 0 002-.43z",
    className: "cls-9",
    "data-v-03e48ff6": ""
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M351.07 127.9c-1.22.38-9.48-1.12-10.58-1.28-5.18-.76-10.12 2.14-11 6.47s2.56 8.46 7.75 9.22 10.12-2.14 11-6.47a6.76 6.76 0 00-.66-4.56c1.66-.78 3.49-3.38 3.49-3.38z",
    className: "cls-10",
    "data-v-03e48ff6": ""
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.31,
    cy: 134.87,
    rx: 9.08,
    ry: 7.59,
    className: "cls-11",
    "data-v-03e48ff6": ""
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.83 141.36l-.22 5 19.68 1 .22-4.74s-1.46-2.72-10.41-3.17-9.27 1.91-9.27 1.91z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12",
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.36 143.26c-.6.85-3.7 0-6.31.25s-8 .84-7.44-.23a11.78 11.78 0 0113.75 0",
    className: "cls-13",
    "data-v-03e48ff6": ""
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.8,
    cy: 134.33,
    rx: 2.81,
    ry: 2.96,
    className: "cls-14",
    "data-v-03e48ff6": ""
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.92,
    cy: 132.9,
    rx: 2.81,
    ry: 1.72,
    transform: "rotate(-1.88 335.26 132.61)",
    className: "cls-11",
    "data-v-03e48ff6": ""
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M308.56 134c-.54-4-4.85-6.87-9.62-6.42-1.45.14-7.36 1.9-8.75 1.82a5 5 0 001.56 2.87 6.16 6.16 0 00-.49 3.35c.54 4 4.84 6.87 9.62 6.42s8.22-4.04 7.68-8.04z",
    className: "cls-10",
    "data-v-03e48ff6": ""
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.41,
    cy: 135.24,
    rx: 8.25,
    ry: 6.89,
    className: "cls-11",
    "data-v-03e48ff6": ""
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.11 140.59l.19 4.56-17.88.83-.18-4.32s1.33-2.46 9.46-2.84 8.41 1.77 8.41 1.77z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12",
    "data-v-03e48ff6": ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.23 143.75c.66.7 3.43-.56 5.9-.64s7.54-.32 6.9-1.24c0 0-6.35-3.79-12.8 1.88",
    className: "cls-13",
    "data-v-03e48ff6": ""
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.71,
    cy: 134.56,
    rx: 2.65,
    ry: 2.78,
    className: "cls-14",
    "data-v-03e48ff6": ""
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.38,
    cy: 133.3,
    rx: 2.65,
    ry: 1.62,
    transform: "rotate(-1.88 297.762 132.91)",
    className: "cls-11",
    "data-v-03e48ff6": ""
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M323 66.36c7.91-.64 44.21 38.09 42.37 63-7.61-4.3-26.24-14.35-31.8-31.16 0 0-14.18 6.31-25.89 5.89l-.59-2.3s-15.49 2.16-19.51 10.6c0-1.19-.06-2.26-.08-3.16C287 82 315.08 67 323 66.36z",
    fill: "url(#Degradado_sin_nombre_2)",
    "data-v-03e48ff6": ""
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M276.49 73.88s-.06.37-.15 1a9.45 9.45 0 01.15-1z",
    fill: "none",
    "data-v-03e48ff6": ""
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M347 71.25a32.36 32.36 0 01-18.16 23.09c-16.11 7.69-29.29 7.08-29.29 7.08l3.22-4.31s-20.12 3.74-26.16 14.49C271 70.71 318.41 42.08 347 71.25z",
    className: "cls-4",
    "data-v-03e48ff6": ""
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M347 71.25s24.24 1.69 31.71 24.47-.3 46.18-.3 46.18-39.54-32.63-41.59-48.33S347 71.25 347 71.25z",
    className: "cls-4",
    "data-v-03e48ff6": ""
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M350.77 74.15s29.73 8.59 27.69 44.28c-2.6-16.96-11.72-31.76-27.69-44.28z",
    className: "cls-18",
    "data-v-03e48ff6": ""
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M356.9 82.59c1.47 2.71 21.24 25.47 19.3 42.67a107.92 107.92 0 01-11-22.17 203.34 203.34 0 00-8.3-20.5z",
    className: "cls-18",
    "data-v-03e48ff6": ""
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M310.77 224.55c3.78 0 43.74-17.53 45-38.76.24-4 3.43-23.23 5.08-25.35-1 23-2.17 40.6-2.17 40.6 1.23 9.47-49 30-49 30S294.33 216.35 292 206.6c8.62 8.57 16.46 17.95 18.77 17.95z",
    fill: "url(#Degradado_sin_nombre_2-2)",
    "data-v-03e48ff6": ""
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.29 162.66c6.41-8.59 9.75-23 .19-25.82s-11.55 24.49-11.55 24.49 4.15 10.99 11.36 1.33z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M362.18 153s.86-2 2.44-1.86 3.69 1 5.91-4.26a3.24 3.24 0 00-1.46-2.55c-1.38-.73-2.63-.82-3.76 1.06s-3.56 5.17-3.13 7.61z",
    fill: "#161614",
    opacity: 0.05,
    "data-v-03e48ff6": ""
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.81,
    cy: 162,
    rx: 2.75,
    ry: 2.89,
    fill: "#d185e3",
    "data-v-03e48ff6": ""
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M299.92 160c.46 0 12.17-1.36 14.63-.52 4 1.35 5.84.24 8.8-.43 2.47-.56 18-1.82 18-1.82s-7.34 6.8-21.87 6.92c-12.48.13-19.56-4.15-19.56-4.15z",
    fill: "#fc5f5f",
    "data-v-03e48ff6": ""
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M297.61 159.13a4.3 4.3 0 001.35.63 9.19 9.19 0 001.47.33c1 .17 2 .31 3 .44q3 .38 6.09.58a87.29 87.29 0 0012.21-.08 91.15 91.15 0 0012.1-1.64 45.69 45.69 0 005.9-1.55 6.34 6.34 0 004.11-4.11h.05a6.12 6.12 0 01-4.09 4.32 46.75 46.75 0 01-5.93 1.6 93.45 93.45 0 01-12.13 1.72 91 91 0 01-12.25-.12c-2-.14-4.08-.32-6.1-.57-1-.12-2-.26-3-.43a7.1 7.1 0 01-1.5-.35 3.37 3.37 0 01-1.35-.76h.06z",
    fill: "#704c2e",
    "data-v-03e48ff6": ""
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M346.4 72l-3 1.82s-11-3-17.89 1c0 0 14-1.18 14.89 2.52s-2.63 8.74-2.21 8.44 6.99-6.15 8.21-13.78z",
    className: "cls-18",
    "data-v-03e48ff6": ""
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M271.18 379.76c-1.3 1.92-2.31 9.88-1.24 11.37s13.95 10 40.2 9.63 61.86-9.7 65.86-13.61-3.06-12.49-4.13-12.12-34.41 14.17-59.59 14.17-41.1-9.44-41.1-9.44z",
    className: "cls-24",
    "data-v-03e48ff6": ""
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M363 198.32c-16.67-1.12-27.19 17.15-30.74 21.37s-13.48 16.9-13.48 21.13-5.08 63-3.66 73.07 17.37 39.11 17.72 50.71 5.32 40.26 6.39 40.26 36.89-6.71 42.21-13.05c0 0-9.93-16.78-12.77-30.94s-9.93-35.42-9.22-44.37 12.06-61.52 13.83-74.94 6.39-42.13-10.28-43.24z",
    className: "cls-24",
    "data-v-03e48ff6": ""
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b840c",
    d: "M337.57 361.61l1.42 4.85 26.37-5.72-.95-4.84-26.84 5.71z",
    "data-v-03e48ff6": ""
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M379.78 83.92a14.22 14.22 0 00-.59-1.7c4.86-39.56-24.19-48.14-29.88-50.06s-19.11-6.54-39.44 3.29c-24.07 11.63-28 47.67-28 47.67s-22.88.49-22.47 5.53 14.13 15.35 47 15.29c11.06 0 26.18-2.26 29.72-2.48s51.13 10.25 43.66-17.54z",
    className: "cls-26",
    "data-v-03e48ff6": ""
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306 55.07c-1.68.22 11-27.63 27.08-28.29s29.58 12.83 29.58 12.83-20.19-9.7-29.58-6.25S322.44 52.94 306 55.07z",
    className: "cls-26",
    "data-v-03e48ff6": ""
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M348.89 96.64c-5.73-.06-14.47-1.47-23.12-3.47-2.76-2.11-6.65-5.52-6.14-7.66.78-3.29 3-6.58 2.34-15.14S316.5 59.52 317.12 58 334 39.94 341.07 37.47s24.1 3.9 24.1 3.9c-9.08-6.42-20.35-10.64-29.58-9.65s-21.9 26.51-23 27.3c-8.27 5.92-8.52 20.93-8.19 27.64a23.75 23.75 0 01-5.73-3.13 72.4 72.4 0 01-11.2-12.4s-13.76 14.07 9.47 21a176.93 176.93 0 0051.13 7c10.85 0 27.34-4.61 29.84-9.43a57.8 57.8 0 01-29.02 6.94z",
    fill: "#4c4c4c",
    opacity: 0.22,
    "data-v-03e48ff6": ""
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M346.83 526.3c0-15.1-9-110.17-9-110.17s-43.1-6.71-41-1.67-8 104.57-6.39 110.16 16 111.28 16 111.28 2.26 1.14 6 2.65L298.66 528s8.09-64.39 8.48-102.63c1.79.14 13.7 1.86 20.65 1.7 2.9 26.57 3.11 49.11 10 98.84l12.44 119.88a32.4 32.4 0 0011.54-3.22c1.47-.73-14.94-101.17-14.94-116.27z",
    fill: "url(#Degradado_sin_nombre_3-2)",
    opacity: 0.4,
    "data-v-03e48ff6": ""
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M345.26 706.49c-17.62 0-33.51 1.36-44.76 3.54-3.37-.1-6.84-.16-10.38-.16-34.09 0-61.72 5.09-61.72 11.37s27.63 11.38 61.72 11.38c17.62 0 33.51-1.36 44.76-3.54 3.38.1 6.84.16 10.38.16 34.09 0 61.72-5.1 61.72-11.38s-27.63-11.37-61.72-11.37z",
    fill: "#303030",
    opacity: 0.2,
    "data-v-03e48ff6": ""
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287 631.53a2.71 2.71 0 013.05-3.13 66 66 0 009.44 1.06 21.79 21.79 0 0011.66-3 3.53 3.53 0 015.24 2.77c2.13 17.66 6.76 69.42 6 70.71-.9 1.53 0 2.69.61 3.62s1.71 14.17 1.71 14.17a23.82 23.82 0 01-9.61 2.16 32.1 32.1 0 00-2-6.05l-2.73 7.45c-5.58 1.45-23.15 4.57-29 4.48-7.61-.11-13.68-1.58-13.52-3s.81-9.62 10.78-11.42c6.41-1.15 17.54-9.68 17.54-9.68z",
    className: "cls-31",
    "data-v-03e48ff6": ""
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323 703.52c-.58-.93-1.51-2.1-.61-3.62.75-1.29-3.86-52.95-6-70.65-3.31.93-6.35 3.68-6.17 10.72 0 0 6 49 5.82 52.76s-7.94 8.26-5.32 9 7 1.18 7.86 3.26c.63 1.57 1.38 10.07 1.72 14.22a24.57 24.57 0 004.4-1.52s-1.1-13.24-1.7-14.17z",
    fill: "url(#Degradado_sin_nombre_2-3)",
    opacity: 0.2,
    "data-v-03e48ff6": ""
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M310.23 714.22c-.73 3.37-15.39 6.23-20.44 7.74s-12.87.48-17.64-.11c-2.75-.33-2.82-2.86-2.34-5a13.77 13.77 0 00-1.92 5.88c-.16 1.39 5.91 2.86 13.52 3 5.87.09 23.44-3 29-4.48l2.73-7.45c.63-5.73-2.14-2.95-2.91.42z",
    fill: "url(#Degradado_sin_nombre_2-4)",
    "data-v-03e48ff6": ""
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M344.23 633a3 3 0 013.47-3.45 64.3 64.3 0 009 1.15 22.2 22.2 0 0012.88-3.49 2.56 2.56 0 013.85 2c1.77 16 5.77 71 5 72.31-.92 1.51 0 2.69.55 3.63s1.47 14.2 1.47 14.2a23.93 23.93 0 01-9.64 2 31.64 31.64 0 00-1.87-6.09l-2.86 7.39c-5.6 1.35-23.21 4.14-29.09 3.95-7.6-.26-13.65-1.85-13.46-3.22s1-9.61 11-11.22c6.42-1 17.7-9.35 17.7-9.35z",
    className: "cls-31",
    "data-v-03e48ff6": ""
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M379 705.23c-.56-.94-1.47-2.12-.55-3.63.78-1.27-3-53-4.8-70.76-3.32.88-6.41 3.57-6.35 10.61 0 0 5.19 49.11 4.93 52.87s-8.07 8.11-5.46 8.89 7 1.31 7.8 3.41c.61 1.58 1.21 10.09 1.48 14.25a24.13 24.13 0 004.42-1.44s-.95-13.26-1.47-14.2z",
    fill: "url(#Degradado_sin_nombre_2-5)",
    opacity: 0.2,
    "data-v-03e48ff6": ""
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M366 715.69c-.78 3.36-15.49 5.94-20.56 7.36s-12.88.24-17.64-.43c-2.74-.39-2.76-2.92-2.25-5a13.63 13.63 0 00-2 5.85c-.19 1.37 5.86 3 13.46 3.22 5.88.19 23.49-2.6 29.09-3.95l2.86-7.39c.67-5.74-2.19-3.01-2.96.34z",
    fill: "url(#Degradado_sin_nombre_2-6)",
    "data-v-03e48ff6": ""
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M381.44 391.81s-9.93-16.78-12.77-30.94-9.93-35.42-9.22-44.37 12.06-61.52 13.83-74.94c.89-6.76 2.51-17.41 1.75-26.45a559.74 559.74 0 00-15.23 10.79c-.71 4.85-10.64 80.53-10.29 89.48s-2.48 11.93 1.78 28c3.49 13.15 8.89 45.36 10.72 56.52 8.68-2.38 17.07-5.27 19.43-8.09z",
    fill: "url(#Degradado_sin_nombre_3-3)",
    opacity: 0.3,
    "data-v-03e48ff6": ""
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M365.37 215.14c-14.94 0 3.56 27.2 10.81 80.57 1.44 10.57 6.7 34.17 6.49 45.61 3.36 14.11 15 7 15 2.59.11-21.2-10.82-128.77-32.3-128.77z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M382.67 341.32c-4.92 26.65-12.53 86.53-12.53 86.53l7.72 7.67s17.76-79 19.8-91.61c.64-12.52-12.75-14.58-14.99-2.59z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M381.48 436.88a29.44 29.44 0 00.34-10.23c-1.95-15.34-20-15.14-20.2 14.18l-.15.12c-.38 5.64 3.41 27.07 5.21 27.11 1.33 0 2.37-.86 2.44-2.69 1.05 5.33 2.27 9.74 3.09 9.76 1.79 0 3.09-1.61 2.1-5-.49-1.65-.84-7.63-1.05-13.53 1.67 7.79 4.24 16.77 5.32 16.68 1.63-.14 2.68-1.91 1.51-5.16-.64-1.78-1.55-9-2.24-15.41 1.64 7.46 3.79 15.07 4.84 15 1.8-.13 2.94-1.9 1.65-5.16-1.09-2.75-2.49-19.55-2.86-25.67z",
    className: "cls-2",
    "data-v-03e48ff6": ""
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M356.42 230.5s22.81 93.33 22.81 110.88l-8.79 70.94 13.13 3.73 16.07-65.12a26.14 26.14 0 00.6-9.16c-2.74-24.95-9.58-141-36.93-141-14.03-.02-6.89 29.73-6.89 29.73z",
    className: "cls-3",
    "data-v-03e48ff6": ""
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M290.16 199.68c2.1-2.29 9.14 19 8.79 24.64s-10.29 61.89-8.52 71.58-8.67 27.31-9 38.5-5.34 65.6-5.34 65.6-14.55-1.86-13.84-4.1 6.75-30.56 8.87-39.9 4.26-55.55 3.19-61.14-14.91-61.58 15.85-95.18z",
    className: "cls-24",
    "data-v-03e48ff6": ""
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M126.94 588.78L29 615.06a2.46 2.46 0 000 4.82l98 26.28a3 3 0 001.52 0l98-26.28a2.46 2.46 0 000-4.82l-98-26.28a3 3 0 00-1.58 0z",
    className: "cls-39",
    "data-v-03e48ff6": ""
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M226.44 615.06l-98-26.28a3 3 0 00-1.52 0L29 615.06a1.16 1.16 0 100 2.19l98 26.28a3 3 0 001.52 0l98-26.28a1.16 1.16 0 100-2.19z",
    fill: "#e6e6e6",
    "data-v-03e48ff6": ""
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87 623.13l51.4-20.16-5.36-2.07-54.38 22.23h8.34z",
    className: "cls-39",
    "data-v-03e48ff6": ""
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd1d2",
    d: "M123.53 289.66h8.33v333.47h-8.33z",
    "data-v-03e48ff6": ""
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#a9abac",
    d: "M127.7 289.66h4.17v333.47h-4.17z",
    "data-v-03e48ff6": ""
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M114.67 387l-79.46-83.56a20.08 20.08 0 010-27.4l79.46-83.51a17.79 17.79 0 0126.06 0L220.19 276a20.08 20.08 0 010 27.4L140.73 387a17.79 17.79 0 01-26.06 0z",
    fill: "#ffef1b",
    "data-v-03e48ff6": ""
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M114.67 389.27l-79.46-83.51a20.08 20.08 0 010-27.4l79.46-83.51a17.79 17.79 0 0126.06 0l79.46 83.51a20.08 20.08 0 010 27.4l-79.46 83.51a17.79 17.79 0 01-26.06 0z",
    className: "cls-26",
    "data-v-03e48ff6": ""
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7 381a13.23 13.23 0 01-9.63-4.18l-71-74.65a14.86 14.86 0 010-20.25l71-74.64a13.17 13.17 0 0119.26 0l71 74.64a14.86 14.86 0 010 20.25l-71 74.65a13.23 13.23 0 01-9.63 4.18zm-79.09-97.42l1.56 1.64a10 10 0 000 13.68l71 74.64a8.88 8.88 0 0013 0l71-74.64a10 10 0 000-13.68l-71-74.64a8.88 8.88 0 00-13 0l-71 74.64z",
    "data-v-03e48ff6": ""
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.67 327.89a10 10 0 11-10-10.48 10.23 10.23 0 0110 10.48zM127.7 245.75c-9.34 0-15.49 10.78-13.87 21s6.21 44.81 13.87 44.81S140 277 141.57 266.74s-4.57-20.99-13.87-20.99z",
    "data-v-03e48ff6": ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225 283.4l-51.65-54.28c20.11 19.88.39 141.2-68.71 149.6l14.83 15.59a11.26 11.26 0 0016.48 0L225 300.72a12.69 12.69 0 000-17.32z",
    fill: "#773c16",
    opacity: 0.16,
    style: {
      mixBlendMode: "multiply"
    },
    "data-v-03e48ff6": ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.304d1ad38e86cd8647af5e12cc52757e.svg";
export { ForwardRef as ReactComponent };